import { render, staticRenderFns } from "./table-tasks-row.vue?vue&type=template&id=2e8d3f5b&scoped=true&"
import script from "./table-tasks-row.vue?vue&type=script&lang=js&"
export * from "./table-tasks-row.vue?vue&type=script&lang=js&"
import style0 from "./table-tasks-row.vue?vue&type=style&index=0&id=2e8d3f5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8d3f5b",
  null
  
)

export default component.exports